import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import MCard from "components/Shared/MCard.tsx";
import { updateUserProfile } from "actions/user";

class PersonalInfo extends Component {
  constructor(props) {
    super(props);

    this.getDefs = this.getDefs.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  getDefs() {
    const { initialValues } = this.props;
    let roles = "";
    initialValues.roles.forEach((value, index) => (
      roles += `${value}${(initialValues.roles.length - 1 !== index) ? "," : ""}`
    ));
    return [
      { key: "username", label: "Username", value: initialValues.username, editable: false },
      { key: "firstName", label: "First Name", value: initialValues.firstName },
      { key: "lastName", label: "Last Name", value: initialValues.lastName },
      { key: "email", label: "Email", value: initialValues.email, editable: false },
      { key: "roleName", label: "Roles", value: roles, editable: false }
    ];
  }

  handleSave(editedData, editedObj) {
    const { initialValues } = this.props;
    let updatedProfile = { ...initialValues };
    updatedProfile.firstName = editedObj.firstName
      ? editedObj.firstName : initialValues.firstName;
    updatedProfile.lastName = editedObj.lastName
      ? editedObj.lastName : initialValues.lastName;
    this.props.updateUserProfile({ ...updatedProfile });
  }

  render() {
    return (
      <MCard
        title="Personal Information"
        className="profile-wrapper"
        isEditable={true}
        fields={this.getDefs()}
        onEditFinished={this.handleSave}
      />
    );
  }
}

PersonalInfo.propTypes = {
  updateUserProfile: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired
};

const mstp = (state) => ({
  initialValues: state.user.profile
});

const mdtp = (dispatch) => ({
  updateUserProfile(userData) {
    dispatch(updateUserProfile(userData));
  }
});

export default connect(mstp, mdtp)(PersonalInfo);
